export const QUERY_PARAM_EPICS = 'epics' as const;
export const QUERY_PARAM_VERSIONS = 'versions' as const;
export const QUERY_PARAM_UNSCHEDULED_WORK = 'unscheduledWork' as const;
